import { useQuery } from '@tanstack/react-query';

import { useProfile } from 'context/profile';
import { dischargeCalendarQueryKeys, indexDischargeCalendarWeek } from 'services/api/dischargeCalendar';
import {
  useDischargeCalendarFilters,
  useDischargeCalendarSearch,
  useTwoWeekViewState,
  useWeekViewState,
} from 'stores/dischargeCalendarStore';

interface UseDischargeCalendarWeekOptions {
  weeks?: 1 | 2;
}

export default function useDischargeCalendarWeek({ weeks = 1 }: UseDischargeCalendarWeekOptions = {}) {
  const { profile } = useProfile();
  const filters = useDischargeCalendarFilters();
  const search = useDischargeCalendarSearch();
  const weekView = useWeekViewState();
  const twoWeekView = useTwoWeekViewState();
  const { startDate, endDate } = weeks === 2 ? twoWeekView : weekView;

  const queryParams = { startDate, endDate, filters, search };

  return useQuery({
    queryKey: dischargeCalendarQueryKeys.week({
      clientId: profile.actingClientId,
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      filters,
      search,
    }),
    queryFn: ({ signal }) => indexDischargeCalendarWeek(queryParams, signal),
    staleTime: 30000,
  });
}
